import { render, staticRenderFns } from "./ClinicNewAppointment.vue?vue&type=template&id=98170ee6&scoped=true"
import script from "./ClinicNewAppointment.vue?vue&type=script&lang=js"
export * from "./ClinicNewAppointment.vue?vue&type=script&lang=js"
import style0 from "./ClinicNewAppointment.vue?vue&type=style&index=0&id=98170ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98170ee6",
  null
  
)

export default component.exports